import React, { Component } from 'react';
import {Nav,NavItem,NavLink,Row,Col,TabContent,TabPane,  } from 'reactstrap';
import classnames from 'classnames';
import {staticTitles, whiteLabelStyling} from '../../utils/constants'
import { connect } from 'react-redux';

class TabBar extends Component {
    constructor(props){
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
          activeTab: '1'    
        }
      }
    toggle(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

  render() {
    const { activeTab } = this.props;
    let {isSetupSkipped} =this.props.user.organizationId

    return (
        <div className="col-md-12 col-sm-12 pl-0 pr-0 analytics-tabs">
              <Nav tabs>
                  {isSetupSkipped!==true? <NavItem>
                    <NavLink className={classnames({ active: activeTab === '1' })} 
                   
                    onClick={() => this.props.history.push('overview')}>Overview</NavLink>
                  </NavItem>
                  :null}
                  <NavItem>
                    <NavLink 
                    className={classnames({ active: activeTab === '2' })} onClick={() => this.props.history.push('users')}>Users</NavLink>
                  </NavItem>
                  {isSetupSkipped!==true?<NavItem>
                    <NavLink 
                      className={classnames({ active: activeTab === '3' })} onClick={() => this.props.history.push('tools')}>Tools</NavLink>
                  </NavItem>
                  :null}
                  {isSetupSkipped!==true?<NavItem>
                    <NavLink 
                      className={classnames({ active: activeTab === '4' })} onClick={() => this.props.history.push('charts')}>Charts</NavLink>
                  </NavItem>:null}
                  {isSetupSkipped!==true?<NavItem>
                    <NavLink
                       className={classnames({ active: activeTab === '5' })} onClick={() => this.props.history.push('actions')}>Actions</NavLink>
                  </NavItem>:null}
                  <NavItem>
                    <NavLink 
                    className={classnames({ active: activeTab === '6' })} onClick={() => this.props.history.push('stories')}>{staticTitles.stories}</NavLink>
                  </NavItem> 
              </Nav>
        </div>
    )
  }
}

const mapStateToProps = state => ({
  userAnalytics: state.dashboard.UsersAnalytics,
  userMetrices: state.dashboard.UsersMetrics,
  user: state.user.profile
});

export default connect(mapStateToProps)(TabBar);